import { supabase } from '../lib/supabase';

export const companyInfoService = {
	// Get company information
	async getCompanyInfo() {
		try {
			const { data, error } = await supabase
				.from('company_info')
				.select('*');

			if (error) throw error;
			return data;
		} catch (error) {
			console.error('Error fetching company info:', error);
			throw error;
		}
	},

	// Create company information
	async createCompanyInfo(companyData) {
		try {
			const { data, error } = await supabase
				.from('company_info')
				.insert([companyData])
				.select()
				.single();

			if (error) throw error;
			return { data, error: null };
		} catch (error) {
			console.error('Error creating company info:', error);
			return { data: null, error };
		}
	},

	// Update company information
	async updateCompanyInfo(id, updates) {
		try {
			const { data, error } = await supabase
				.from('company_info')
				.update(updates)
				.eq('id', id)
				.select()
				.single();

			if (error) throw error;
			return { data, error: null };
		} catch (error) {
			console.error('Error updating company info:', error);
			return { data: null, error };
		}
	},

	// Delete company information
	async deleteCompanyInfo(id) {
		try {
			const { error } = await supabase
				.from('company_info')
				.delete()
				.eq('id', id);

			if (error) throw error;
			return { error: null };
		} catch (error) {
			console.error('Error deleting company info:', error);
			return { error };
		}
	}
};
